import { QualificationDetailResponse } from '@doda/api-client/aspida/@types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { CreateJobListHeaderText } from 'pages/DodaFront/View/CareerRecommendJobList/components/BodyHeader/logics/createJobListHeaderText';
import { CreateBreadcrumb } from 'pages/DodaFront/View/CareerRecommendJobList/components/Breadcrumb/createBreadcrumb';
import { CreateSearchConditionText } from 'pages/DodaFront/View/CareerRecommendJobList/logics/createSearchConditionText';
import { RootState } from 'redux/store';

/**
 * 初期型
 * @interface CareerRecommendJobListState
 */
export interface CareerRecommendJobListState {
  /** 求人リストヘッダーテキスト */
  jobListHeaderText: CreateJobListHeaderText;
  /** パンくずデータ */
  breadcrumbData: CreateBreadcrumb;
  /** 検索条件テキスト */
  searchConditionText: CreateSearchConditionText;
  /** 資格詳細 */
  qualification: QualificationDetailResponse;
}

/**
 * 初期状態
 * @type {CareerRecommendJobListState}
 */
export const careerRecommendJobListInitialState: CareerRecommendJobListState = {
  jobListHeaderText: {
    title: '',
    explainText: '',
  },
  breadcrumbData: [],
  searchConditionText: '',
  qualification: {},
};

export const careerRecommendJobListSlice = createSlice({
  name: 'careerRecommendJobList',
  initialState: careerRecommendJobListInitialState,
  reducers: {
    /**
     * キャリア推薦求人数値のプロパティを設定する
     * @param {CareerRecommendJobListState} state - 現在の状態
     * @param {PayloadAction<CareerRecommendJobListState>} action - アクションのペイロード
     */
    setCareerRecommendJobListProps: (
      state,
      { payload }: PayloadAction<CareerRecommendJobListState>
    ) => {
      state.jobListHeaderText = payload.jobListHeaderText;
      state.breadcrumbData = payload.breadcrumbData;
      state.searchConditionText = payload.searchConditionText;
      state.qualification = payload.qualification;
    },
  },
});

export const { setCareerRecommendJobListProps } =
  careerRecommendJobListSlice.actions;

// Reducer
export const careerRecommendJobListReducer =
  careerRecommendJobListSlice.reducer;

/**
 * 求人リストヘッダーテキストセレクター
 * @param {RootState} state - グローバルステート
 * @returns {CreateJobListHeaderText} 求人リストヘッダーテキスト
 */
export const jobListHeaderTextSelector = (
  state: RootState
): CreateJobListHeaderText => state.careerRecommendJobList.jobListHeaderText;

/**
 * パンくずデータセレクター
 * @param {RootState} state - グローバルステート
 * @returns {CreateBreadcrumb} パンくずデータ
 */
export const breadcrumbDataSelector = (state: RootState): CreateBreadcrumb =>
  state.careerRecommendJobList.breadcrumbData;

/**
 * 検索条件テキストセレクター
 * @param {RootState} state - グローバルステート
 * @returns {CreateSearchConditionText} 検索条件テキスト
 */
export const searchConditionTextSelector = (
  state: RootState
): CreateSearchConditionText =>
  state.careerRecommendJobList.searchConditionText;

/**
 * 資格詳細セレクター
 * @param {RootState} state - グローバルステート
 * @returns {QualificationDetailResponse} 資格詳細
 */
export const qualificationSelector = (
  state: RootState
): QualificationDetailResponse => state.careerRecommendJobList.qualification;
